import Brilliant from '../assets/brilliant.svg';
import Great from '../assets/great.svg';
import Best from '../assets/best.svg';
import Excellent from '../assets/excellent.svg';
import Good from '../assets/good.svg';
import Book from '../assets/book.svg';
import Inaccuracy from '../assets/inaccuracy.svg';
import Mistake from '../assets/mistake.svg';
import Miss from '../assets/miss.svg';
import Blunder from '../assets/blunder.svg';
import Empty from '../assets/empty.svg';
import { MoveType } from '../types/MoveType';

// The CSS modifier that colours a move-type label (.cm-cp-move-type in site.css): yellow inaccuracy,
// orange mistake, light-red miss, red blunder, one "good" colour for strong moves.
export function moveTypeClass(moveType: MoveType | null | undefined): string {
  switch (moveType) {
    case MoveType.Blunder:
      return 'blunder';
    case MoveType.Mistake:
      return 'mistake';
    case MoveType.Miss:
      return 'miss';
    case MoveType.Inaccuracy:
      return 'inaccuracy';
    case MoveType.Brilliant:
    case MoveType.Great:
    case MoveType.Best:
    case MoveType.Excellent:
      return 'good';
    default:
      return '';
  }
}

export function getIcon(moveType: MoveType | undefined) {
  if (moveType == MoveType.Brilliant) {
    return Brilliant;
  }
  if (moveType == MoveType.Great) {
    return Great;
  }
  if (moveType == MoveType.Best) {
    return Best;
  }
  if (moveType == MoveType.Excellent) {
    return Excellent;
  }
  if (moveType == MoveType.Good) {
    return Good;
  }
  if (moveType == MoveType.Book) {
    return Book;
  }
  if (moveType == MoveType.Inaccuracy) {
    return Inaccuracy;
  }
  if (moveType == MoveType.Mistake) {
    return Mistake;
  }
  if (moveType == MoveType.Miss) {
    return Miss;
  }
  if (moveType == MoveType.Blunder) {
    return Blunder;
  }
  return Empty;
}
